export default __webpack_public_path__ + "static/media/ourbenifit.2cfdee80.png";